import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { ModalService } from '../../shared/modal/modal.service';
import { Router } from "@angular/router";
import { MatDialog } from '@angular/material/dialog';
import { ApplicationsLinkComponent } from '../modal/applications-link/applications-link.component';
import { CurrencyPipe } from '@angular/common';
import { MessageComponent } from '../modal/message/message.component';
import { BasicQuestionComponent } from 'app/shared/modal/basic-question/basic-question.component';
import { GlobalService } from '../../services/global.service';

@Component({
    selector: 'app-nav-card',
    templateUrl: './nav-card.component.html',
    styleUrls: ['nav-card.component.css']
})

export class NavCardComponent implements OnInit {
    height = '160';
    width = '260';
    clientFirstName: string;
    spouseFirstName: string;

    @Input() icon: string = '';
    @Input() iconColor: string = '';
    @Input() color: string = '';
    @Input() title: string = '';
    @Input() subtitle: string = '';
    @Input() description: string = '';
    @Input() cardHeight: string;
    @Input() cardWidth: string;
    @Input() actionButton: boolean = false;
    @Input() isToolsAndResources: boolean = false; 
    @Input() image: string = '';
    @Input() isCreateClient: boolean = false;
    @Input() isEditClient: boolean = false;
    @Input() isDisabled: boolean = false;
    @Input() isCreateReport: boolean = false;
    @Input() isHCIllustration: boolean = false;
    @Input() isCoverageFilled: boolean = false;
    //@Input() isApplication: boolean = false;
    @Input() field1Label: string = '';
    @Input() field1Value: string = '';
    @Input() field2Label: string = '';
    @Input() field2Value: string = '';
    @Input() field3Label: string = '';
    @Input() field3Value: string = '';
    @Input() field4Label: string = '';
    @Input() field4Value: string = '';
    @Input() urlOverride: string = '';
    @Input() showQuestionnaire: boolean = true;
    @Input() source: string = '';
    @Input() spouseField1Label: string = '';
    @Input() spouseField1Value: string = '';
    @Input() spouseField3Label: string = '';
    @Input() spouseField3Value: string = '';
    @Input() isShowSpouse: boolean ;
    @Input() sourceCard: string = '' ;
    @Input() isAlreadyUpdate: boolean = false;
    @Input() isSSEligible: boolean = false;
    @Input() isSpouseSSEligible: boolean = false;
    @Input() showApplications: boolean = true;
    @Input() fromApplicationStore: boolean = false;
    @Input() applicationLink: string = '';
    @Input() displayConnectedIcon: boolean = false;
    @Input() sectionUnlocked: boolean = true;
    @Output() newItemEvent = new EventEmitter<any>();

    public displayOverflowScroll: boolean = false;

    constructor(private globalService: GlobalService, private currencyPipe: CurrencyPipe, private modalService: ModalService, private router: Router, public matDialog: MatDialog) {
        this.newItemEvent = new EventEmitter();       
    }
    
    ngOnInit() {
        console.log('this.title', this.title)
        this.displayOverflowScroll = this.title == "Medicare Coverage" && (this.spouseField1Value.length > 0) && Number(this.cardHeight) < 235;
        if (this.title == 'Pre-65 Coverage') {
            if (this.field1Value != 'Yes') {
                this.field3Value = '--'
            }
            if (this.spouseField1Value != 'Yes' && this.isShowSpouse) {
                this.spouseField3Value = '--'
            }
        }
        if (this.field1Value && this.title != 'Income' && this.title != 'Medicare Coverage'){
            console.log('remove comma');
            this.field1Value = this.removeFirstComma(this.field1Value.toString());
        }
        if (this.title == 'Medicare Coverage') {
            this.field1Value = this.field1Value.replace(/,\s*$/, "");
            this.field3Value = this.field3Value.replace(/,\s*$/, "");
            if (this.isShowSpouse) {
                this.spouseField1Value = this.spouseField1Value.replace(/,\s*$/, "");
                this.spouseField3Value = this.spouseField3Value.replace(/,\s*$/, "");

            }
        }

        if(this.title == 'Income' && this.field1Value != '--' && this.field1Value.includes("to") && this.sourceCard != 'ssCard'){
            var bracket = this.field1Value.split(' to ');
            var fromValue = (bracket[0].replace('$', '')).replace(',','');
            var toValue = (bracket[1].replace('$', '')).replace(',','');
            this.field1Value = this.currencyPipe.transform(fromValue, 'USD', true, '1.0-0') + ' to ' + this.currencyPipe.transform(toValue, 'USD', true, '1.0-0');
        }

        if (this.cardHeight) {
            this.height = this.cardHeight;
            console.log('this.height', this.height);
            console.log(this.title);
        }
        if (this.cardWidth) {
            this.width = this.cardWidth;
        }
        this.clientFirstName = localStorage.getItem('clientFirstName');
        this.spouseFirstName = localStorage.getItem('spouseFirstName');

        
    }

    redirect(passedValue = '') {
        if(this.urlOverride != ''){
            //if in here, we allow overriding of the specified title matches below
            this.router.navigate([this.urlOverride]);
        }

        if (this.title == 'Information Needed') {
            //this.router.navigate(['/reports/hc-questionnaire'], { state: { params: '' } });
            this.router.navigate(['/clients/edit/healthcare'], { state: { params: '' } });
        }

        if (this.title == 'Pre-65 Coverage' && this.isDisabled == false) {
            //this.router.navigate(['/reports/hc-questionnaire'], { state: { params: 'pre65' } });
            this.router.navigate(['/clients/edit/healthcare'], { state: { params: 'pre65' } });
        }
        if (this.title == 'Medicare Coverage' && this.isDisabled == false) {
            //this.router.navigate(['/reports/hc-questionnaire'], { state: { params: 'medCoverage' } });
            this.router.navigate(['/clients/edit/healthcare'], { state: { params: 'medCoverage' } });
        }
        if (this.title == 'Income' && this.isDisabled == false) {
            if(this.sourceCard == 'ssCard'){
                this.router.navigate(['/clients/edit/social-security'], { state: { params: 'income' } });
            } else {
                //this.router.navigate(['/reports/hc-questionnaire'], { state: { params: 'income' } });
                this.router.navigate(['/clients/edit/healthcare'], { state: { params: 'income' } });
            }
        }
        if (this.title == "Additional Questions") {
            //this.router.navigate(['/reports/hc-questionnaire'], { state: { params: 'additionalQuestions' } });
            this.router.navigate(['/clients/edit/healthcare'], { state: { params: 'additionalQuestions' } });
        }
        if (this.title == 'Metro Area') {
            //this.router.navigate(['/reports/ltc-questionnaire'], { state: { params: 'ltcMetroArea' } });
            this.router.navigate(['/clients/edit/long-term-care'], { state: { params: 'ltcMetroArea' } });
        }
        if (this.title == "Long Term Care Additional Questions") {
            //this.router.navigate(['/reports/ltc-questionnaire'], { state: { params: 'additionalQuestions' } });
            this.router.navigate(['/clients/edit/long-term-care'], { state: { params: 'additionalQuestions' } });
        }


        if (this.title == "Add New Client") {
            // this.modalService.add('add-edit-client', { ID: 0 });
            localStorage.setItem('advisor', "");
            localStorage.setItem('isCreateClient', "True");
            localStorage.setItem('isEditClient', "False");
            this.router.navigate(['/clients/create']);
        }

        if(this.title == "Add New Advisor"){
            this.router.navigate(['/advisors/create'], { state: { ID: 0 } });
        }

        if (this.title == "Personal Information") {
            this,this.commonSetItemWhileNavigate("0");
        }
        if (this.title == "Health Information") {
            this,this.commonSetItemWhileNavigate("1");
        }
        if (this.title == "Income Information") {
            this,this.commonSetItemWhileNavigate("2");
        }
        if (this.title == "Retirement Information") {
            this,this.commonSetItemWhileNavigate("0");
        }
        if (this.title == "Edit Client") {
            let clientID = localStorage.getItem('selectedClient');
            this.modalService.add('add-edit-client', { ID: clientID});
            // this.router.navigate(['/clients/edit']);
        }

        if (this.title == "Create New Illustration") {
            this.router.navigate(['/reports/create/illustration'])

        }
        // if (this.title == "View Past Illustration") {
        //     this.router.navigate(['/reports/view']);
        // }

        if (this.title == 'Healthcare Express') {
            this.router.navigate(['/hc-express-questionnaire']);
        }

        if (this.title == 'Retirement Suite') {
            if(this.sectionUnlocked){
                this.router.navigate(['/retirement-suite']);
            } else {
                this.purchaseRetirementSuite();
            }
        }

        if (this.title == "Download Previous Report") {
            this.router.navigate(['/reports/download']);
        }

        if (this.title == "Healthcare") {
            //TODO: this should be determined based on the clients information we already have stored for that client in the DB
            //let isHCQuestionnaireFilled = localStorage.getItem('isHCQuestionnaireFilled');
            if (this.showQuestionnaire) {
                //this.router.navigate(['/reports/hc-questionnaire'], { state: { params: '' } });
                this.router.navigate(['/clients/edit/healthcare'], { state: { params: '' } });
            } else {
                //this.router.navigate(['/reports/healthcare/options']);
                this.router.navigate(['/clients/edit/healthcare/options']);
            }
           // this.router.navigate(['/reports/create/hc']);

        }

        if ((this.title == "Social Security" && this.isSSEligible && this.isSpouseSSEligible || this.title == "Retirement" || this.title == "Family") && !this.isAlreadyUpdate) {
            //this.router.navigate(['/reports/ss-questionnaire'], { state: { params: '' } });
            let parameter = this.title == "Social Security" ? 'emptyAll': 'empty';
            this.router.navigate(['/clients/edit/social-security'], { state: { params: parameter } });
        }
        if ((this.title == "Social Security" && this.isSSEligible && this.isSpouseSSEligible || this.title == "Retirement" || this.title == "Family") && this.isAlreadyUpdate) {
            //this.router.navigate(['/reports/ss-questionnaire'], { state: { params: 'socialSecurity' } });
            this.router.navigate(['/clients/edit/social-security'], { state: { params: 'socialSecurity' } });
        }
        if (this.title == "Social Security" && !this.isSSEligible && !this.isSpouseSSEligible ) {
            const dialogRef = this.matDialog.open(MessageComponent, {     
                data: { title: 'Cannot Continue', message: 'Client and Spouse Life Expectancy is lower than Social Security eligibility. A report cannot currently be run. <br/> To modify Life Expectancy, open the Client Info Editor from the right side of the client hub page.' }
              });
        } else if (this.title == "Social Security" && !this.isSSEligible) {
            const dialogRef = this.matDialog.open(MessageComponent, {     
                data: { title: 'Cannot Continue', message: 'Client Life Expectancy is lower than Social Security eligibility. A report cannot currently be run. <br/> To modify Life Expectancy, open the Client Info Editor from the right side of the client hub page.' }
              });
        } else if (this.title == "Social Security" && !this.isSpouseSSEligible) {
            const dialogRef = this.matDialog.open(MessageComponent, {     
                data: { title: 'Cannot Continue', message: 'Spouse Life Expectancy is lower than Social Security eligibility. A report cannot currently be run. <br/> To modify Life Expectancy, open the Client Info Editor from the right side of the client hub page.' }
              });
        } 

        if (this.title == "Medicare Means Testing") {
            //this.router.navigate(['/reports/create/mmtv2']);
            //this.router.navigate(['/reports/medicare-means-testing/options']);
            //this.router.navigate(['/reports/create/mmtq']); //default to just be Quick Report
            this.router.navigate(['/clients/edit/healthcare']); // Temp fix - they need to fill out income information
        }

        if (this.title == "Long-Term Care") {
            
            //this.router.navigate(['/reports/create/ltc']);
            //TODO: this should be determined based on the clients information we already have stored for that client in the DB
            if(this.showQuestionnaire){
                //this.router.navigate(['/reports/ltc-questionnaire'], { state: { params: '' } });                
                this.router.navigate(['/clients/edit/long-term-care'], { state: { params: '' } });    
            } else {
                //this.router.navigate(['/reports/long-term-care/options']);
                this.router.navigate(['/clients/edit/long-term-care/options']);
            }
        }

        if (this.title == "Combination") {
            //this.router.navigate(['/reports/create/hcltc']);

            //TODO: need to check if HC and LTC questionnaire have been completed
            if (this.showQuestionnaire) {
                //TODO: this needs to be a combination of LTC and HC questionnaire
                //this.router.navigate(['/reports/combined-questionnaire'], { state: { params: '' } });
                this.router.navigate(['/clients/edit/combined'], { state: { params: '' } });
            } else {
                //this.router.navigate(['/reports/combined/options']);
                this.router.navigate(['/clients/edit/combined/options']);
            }
        }

        if (passedValue == "Information Center") {
            this.router.navigate(['/info-center']);
        }

        if (passedValue == "Marketing Material") {
            this.router.navigate(['/marketing-material']);
        }

        if (passedValue == "Applications") {
            this.router.navigate(['/applications']);
        }

        //apps here
        //console.log('fromApplicationStore', this.fromApplicationStore);
        if (this.fromApplicationStore) {// || this.title == 'HealthView Explorer' || this.title == 'Income Replacement Ratio (IRR)' || this.title == 'Snapshot' || this.title =='LTC Map') {
            this.handlePopup(this.title, this.applicationLink);
        }
    }
    
    commonSetItemWhileNavigate(value) {
        localStorage.setItem('isCreateClient', "False");
        localStorage.setItem('isEditClient', "True");
        localStorage.setItem('currentAddEditClientScreen', value);
        this.router.navigate(['/clients/create']);
    }
    handleCreateClientModal() {
        this.modalService.add('add-edit-client', { ID: 0 });
    }
    handlePopup(title, srcURL?: any) {
        console.log(title);
        //TODO: should prob move h/w controls to DB
        let app, width, height;
        if (title == 'HealthView Explorer') {
            //app ='StateSupplemental.aspx';
            width = 1440;
            height = 900;

        } else  if (title == 'Income Replacement Ratio (IRR)') {
            //app = 'irr.aspx';
            width = 840;
            height = 900;

        } else if (title == 'Snapshot') {
            //app = 'minihc.aspx';
            width = 1000;
            height = 900;

        } else if (title == 'LTC Map') {
            //app = 'HVSLTCMap';
            width = 1300;
            height = 900;

        } else {
            //default apps without w/h params to this
            width = 1300;
            height = 900;
        }

        app = srcURL;

        const dialogRef = this.matDialog.open(ApplicationsLinkComponent, {
            width: width,
            height: height,
            data: { title: title, height: height, width: width, app: app }
          });
    }

    purchaseRetirementSuite(){
        const dialogRef = this.matDialog.open(BasicQuestionComponent, {     
                data: { title: 'Notification!',
                btnNoTitle: 'Nevermind',
                btnYesTitle: 'Yes! Please continue!',
                question: 'Are you sure you would like to contiune adding the Retirement Suite to your existing HVS Portal subscription?<br/>This will an additional <b>$29</b> to your monthly subscription, or will create a new monthly transaction.'
            }
        });
    
        dialogRef.afterClosed().subscribe(result => {
            //console.log('result', result);  
            if(result){
                //if Yes - create a new support ticket for Pat to either reach out or to update their existing monthly payment we have on file
                var SupportModel = {
                    AdvisorID: Number(localStorage.getItem('selectedAdvisorID')),
                    OrgID: Number(localStorage.getItem('orgID')),
                    Subject: 'Retirement Suite Purchase Request',
                    Message: 'User would like to purchase the Retirement Suite in HVS Portal. Please update their account with the additional monthly amount of: <b>$29.00</b><br/>If they have an annual subscription, you will to reach out directly for a new monthly transaction.'
                }

                this.globalService.createSupportTicket(SupportModel)
                .subscribe(
                    data => { });

                //display another modal saying it will be enabled in 24hrs, or maybe a snackbar, that someone will reach out if more information is needed
                const dialogRef = this.matDialog.open(MessageComponent, {     
                    data: { title: 'Thank you!', message: 'Your request was successful. Please give us some time to process. If there are any questions our Support staff will reach out.' }
                });

                //just give access right away after the approval to update their account
                localStorage.setItem('retirementSuiteUnlocked', 'true');
                localStorage.setItem('featRetirementSuite', 'true');
                this.globalService.retirementSuiteUnlocked = JSON.parse(localStorage.getItem('retirementSuiteUnlocked'));
                this.globalService.featRetirementSuite = JSON.parse(localStorage.getItem('featRetirementSuite'));

                //TODO: in the future this should be converted to an object to control areas of cards
                this.newItemEvent.emit(true);
            }
        }); 
    }

    //TODO: build out a modal/dialogue function
    /* private displayDialogueModal(title, question, btnNo, btnYes){
        const dialogRef = this.matDialog.open(BasicQuestionComponent, {     
            data: { title: title,
            btnNoTitle: btnNo,
            btnYesTitle: btnYes,
            question: question
        }
        });
    
        dialogRef.afterClosed().subscribe(result => {
            //console.log('result', result);  
            if(result){
                //go to Income section of QQ
                //this.router.navigate(['/clients/edit/healthcare'], { state: { params: 'income' } });
            }
        }); 
    } */

    removeFirstComma(str:string) {
        const indexOfSpace = str.indexOf(',');
      
        return str.substring(indexOfSpace + 1);
      }
}
